import lruDriver from 'localforage-lru-driver/dist/localforage-lru-driver';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isUndefined from 'lodash/isUndefined';

export default {
  ...lruDriver,
  _initStorage: function (options) {
    // cache keys that have been checked already and skip them.
    this._migrated = {};

    this._migrations = options.migrations || [];
    this._latestVersion = this._migrations.length > 0 ? this._migrations[this._migrations.length - 1].version : void 0;

    return lruDriver._initStorage.call(this, options)
      .then(() => {
        this.getItem = getItem;
        this.setItem = setItem;
      });
  },

  getItem,
  setItem,
};

function getItem(key, callback) {
  if (this._migrated[key]) {
    return lruDriver.getItem.call(this, key, callback);
  } else {
    return lruDriver.getItem.call(this, key, callback).then(entry => {
      const entryIsObject = isObject(entry);

      if (entryIsObject && entry.version === this._latestVersion) {
        return entry.data;

      } else if (entry === null) {
        return null;

      } else {
        let version = entryIsObject && isNumber(entry.version) ? entry.version : 0;
        let output = entryIsObject ? entry.data : entry;
        for (let i = 0, len = this._migrations.length; i < len; i++) {
          const migration = this._migrations[i];
          // TODO: support semver?
          if (version < migration.version) {
            version = migration.version;
            output = migration.onUpdate(output);
          }
        }

        if (output !== null && !isUndefined(output)) {
          return this.setItem(key, output).then(() => {
            this._migrated[key] = true;
            return output;
          });
        } else {
          return this.removeItem(key, output);
        }
      }
    })
  }
}

function setItem(key, value, callback) {
  return lruDriver.setItem.call(this, key, {version: this._latestVersion, data: value}, callback);
}



// WEBPACK FOOTER //
// ./src/js/_libs/localforage-migrations/index.js